<template>
  <div class="content">
    <div class="myBiaoZhu" id="myBiaoZhuDiv">
      <img
        id="myBiaoZhu"
        src="../../assets/images/column_highlight.png"
        alt=""
        style="height: 400px; width: 400px"
      />
      <div @click="startBiaoZhu">开始标注</div>
      <div type="text" @click="endBiaoZhu">标注完成</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      banMa: [
        { id: 1, x: 0, y: 100 },
        { id: 2, x: 100, y: 100 },
        { id: 3, x: 200, y: 100 },
      ], //斑马线的数组
      canBiaoZhu: false, //是否可以进行标注
      pointColor: "red", //点的颜色
      pointSize: 10, //点的大小
    };
  },
  methods: {
    //开始标注
    startBiaoZhu() {
      this.canBiaoZhu = true;
    },
    //完成标注
    endBiaoZhu() {
      this.canBiaoZhu = false;
    },
    //根据后台数据循环画点
    initData() {
      this.banMa.forEach((item) => {
        console.log("item", item);
        this.createMarker(item.x, item.y,item.id);
      });
    },

    //画点
    createMarker(x, y,id) {
      let that=this
      var div = document.createElement("div");
      div.className = "marker";
      div.id = "marker" + that.banMa.length;

      // y =y + document.getElementById("myBiaoZhu").offsetTop - this.pointSize / 2;
      // x =x +document.getElementById("myBiaoZhu").offsetLeft -this.pointSize / 2;
      div.style.width = that.pointSize + "px";
      div.style.height = that.pointSize + "px";
      div.style.backgroundColor = that.pointColor;
      div.style.position = "absolute";
      div.style.left = x + "px";
      div.style.top = y + "px";
      div.setAttribute("data-id",id); //设置自定义属性
      div.onclick=function(){that.divClick(id)}//绑定

      div.oncontextmenu = (e) => {
        var id = e.target.id;
        document.getElementById("myBiaoZhuDiv").removeChild(div);
        that.banMa = that.banMa.filter(
          (item) => item.id != id.slice(6, id.length)
        );
        console.log("删除--that.banMa=>", that.banMa);
        if (e && e.preventDefault) {
          //阻止默认浏览器动作(W3C)
          e.preventDefault();
        } else {
          //IE中阻止函数器默认动作的方式
          window.event.returnValue = false;
        }
        return false;
      }; //阻止冒泡行为和默认右键菜单事件，删除该点
      document.getElementById("myBiaoZhuDiv").appendChild(div);
    },

    divClick(id){
      console.log("e=>",id)
      alert(0)
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    // document.getElementById("myBiaoZhu").oncontextmenu = (e) => {
    //   if (e && e.preventDefault) {
    //     //阻止默认浏览器动作(W3C)
    //     e.preventDefault();
    //   } else {
    //     //IE中阻止函数器默认动作的方式
    //     window.event.returnValue = false;
    //   }
    //   return false;
    // }; //阻止冒泡行为和默认右键菜单事件

    // document.getElementById("myBiaoZhu").onmousedown = (e) => {
    //   e = e || window.event;
    //   if (e.button !== 2) {
    //     //判断是否右击
    //     if (this.canBiaoZhu) {
    //       //判断是否可以进行标注
    //       var x = e.offsetX || e.layerX;
    //       var y = e.offsetY || e.layerY;
    //       console.log(x, y);
    //       var myImg = document.querySelector("#myBiaoZhu");
    //       var currWidth = myImg.clientWidth;
    //       var currHeight = myImg.clientHeight;
    //       var ProportionWidthInImg = x / currWidth;
    //       var ProportionHeightInImg = y / currHeight;
    //       // console.log("图片比例高度："+ProportionHeightInImg)
    //       // console.log("图片比例宽度："+ProportionWidthInImg)
    //       this.banMa.push({
    //         id: this.banMa.length + 1,
    //         x,
    //         y,
    //       });
    //       console.log("增加--this.banMa=>", this.banMa);
    //       this.createMarker(x, y);
    //     }
    //   }
    // };

    this.initData();
  
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="less" scoped>
#myBiaoZhuDiv {
    margin:0 auto;
  position: relative;
  width: 400px;
  height: 400px;
  img {
    border: solid 1px #000;
    display: inline-block;
    // margin:100px 100px;
    z-index: 1;
  }
  .marker {
    position: absolute;
    border-radius: 50%;
    z-index: 999;
  }
}
.content{
  width:100%;
  height:100%;

}
</style>